import { Music } from "lucide-react";

const ABOUT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/e88f9df8-0827-4de8-b395-30b21dfa42d4/images/a26bd0d2460ea2b0ad201b816a86f7cfab57742abb210934cbf65ee6d40f6b9e.png";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[color:var(--nr-bg)] py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Left image stack */}
        <div className="lg:col-span-6 relative reveal">
          <div className="relative aspect-[4/5] rounded-xl overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="Awi Rafael — design and music meet renovation"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="hidden md:block absolute -bottom-12 -right-8 w-56 bg-[color:var(--nr-bg-soft)] p-5 rounded-xl border border-[color:var(--nr-line)] shadow-sm">
            <Music size={20} className="text-[color:var(--nr-accent)]" />
            <p className="mt-3 font-serif-display italic text-lg leading-snug text-[color:var(--nr-ink)]">
              "A home should sound like silence and feel like a song."
            </p>
            <p className="mt-3 text-xs uppercase tracking-[0.2em] text-[color:var(--nr-ink-soft)]">
              — Awi Rafael, Creative Partner
            </p>
          </div>
        </div>

        {/* Right copy */}
        <div className="lg:col-span-6 reveal">
          <p className="overline mb-5">Our Story</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[color:var(--nr-ink)]">
            Two fathers,{" "}
            <em className="italic font-light text-[color:var(--nr-accent)]">
              one quiet promise
            </em>{" "}
            — and a brand named after their boys.
          </h2>
          <div className="nr-rule my-8" />
          <div className="space-y-5 text-[color:var(--nr-ink-soft)] text-base lg:text-[1.05rem] leading-relaxed">
            <p>
              Noah+Rayn began over kopi between two friends, talking about the
              kind of homes they wished to raise their sons inside. Noah and
              Rayn — their boys — gave the company its name, and quietly, its
              philosophy: build like a family member is living here.
            </p>
            <p>
              Today, we serve homeowners across Singapore's Resale and BTO
              flats with hacking, tiling, wallpapering, carpentry and full
              interior design — at rates that consistently come in below the
              industry average, without ever cutting where it matters.
            </p>
            <p>
              Joining us as a creative partner is{" "}
              <span className="text-[color:var(--nr-ink)] font-semibold">
                Awi Rafael
              </span>{" "}
              — Singapore's award-winning musician, and a close cousin of our
              founder. He brings an artist's ear for atmosphere into every
              brief: how a hallway should breathe, how a living room should
              hum. <span className="text-[color:var(--nr-ink)] italic">Meet him just below ↓</span>
            </p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 border-t border-[color:var(--nr-line)] pt-8">
            {[
              { k: "Founded", v: "By Two Dads" },
              { k: "Named After", v: "Noah & Rayn" },
              { k: "Crafted With", v: "Awi Rafael" },
            ].map((s, i) => (
              <div key={i} data-testid={`about-fact-${i}`}>
                <div className="text-xs uppercase tracking-[0.18em] text-[color:var(--nr-ink-soft)]">
                  {s.k}
                </div>
                <div className="font-serif-display text-xl mt-1 text-[color:var(--nr-ink)]">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
